<template>
  <SecondaryButton @click="handleClick" textColor="#0965dc">
    <div class="d-flex align-center">
      <inline-svg :src="require('@/assets/svg/comment.svg')" width="20" />
      <v-icon size="1em">
        mdi-plus
      </v-icon>
    </div>
    Add Comment
  </SecondaryButton>
</template>

<script>
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import InlineSvg from "vue-inline-svg";

export default {
  components: {
    SecondaryButton,
    InlineSvg
  },
  name: "ShowCommentsButton",
  methods: {
    handleClick(event) {
      if (!this.loading) {
        this.$emit("click", event);
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
